<template>
  <div :class="['header', {'header--dark': dark}]">
    <Logo class="mr-4" />

    <Menu :menu="menu" />
    <Languages v-if="multiLang" />

    <div v-if="!multiLang" class="logo-text" v-text="config.application.title" />

    <a
        class="sample-button hidden-xs"
        v-if="menu.sampleButton"
    >
      <v-icon size="30px">lab la-instagram</v-icon>
    </a>
  </div>
</template>

<script setup lang="ts">
const config = useConfig()

const { menu, multiLang } = defineProps<{
  menu: IMenu,
  multiPage?: boolean,
  multiLang?: boolean,
  dark?: boolean
}>()
</script>

<style scoped lang="scss">
.header {
  position: relative;
  user-select: none;
  text-align: left;

  :deep(.logo) {
    margin-right: 4px;
  }

  .logo-text {
    vertical-align: top;
    text-align: left;
    font-family: var(--font-primary);
    font-size: 24px;
    display: none;

    @media(max-width: 599px) {
      display: inline-block;
    }
  }

  & + :deep(.hero) {
    margin-top: 120px;

    @media(max-width: 900px) {
      margin-top: 80px;
    }

    @media(max-width: 700px) {
      margin-top: 40px;
    }
  }

  &--dark {
    :deep(.menu__items) ul li a:before {
      background: white;
    }
  }

  &-right {
    position: absolute;
    top: 26px;
    right: 0;
  }

  :deep(.menu) {
    text-align: center;

    ul {
      display: inline-block;
    }
  }

  :deep(.languages) {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: 0;

    @media(max-width: 599px) {
      padding-right: 16px;
      border-right: 1px solid rgba(255, 255, 255, 0.04);
      right: 30px;
    }
  }

  .sample-button {
    position: absolute;
    right: 0;
  }
}
</style>
